import React from 'react';
import DepartmentWorkPlanner from '../../components/DepartmentWorkPlanner';

const FinanceWorkPlanner = () => {
  return <DepartmentWorkPlanner department="finance" departmentName="Finance Department" />;
};

export default FinanceWorkPlanner;
